import { render } from "./PrePrimaryView.vue?vue&type=template&id=7032254a"
import script from "./PrePrimaryView.vue?vue&type=script&lang=js"
export * from "./PrePrimaryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__